import Vue from "vue";
import datesMixin from "../../mixins/datesMixin";

// date helpers for dates
let moment = require("moment");
let date = new Date();

export const namespaced = true;

export const state = {
  booked: false,
  result: {
    trip: {}, //if adding segments to a previous trip
    flight: {},
    car: {},
    hotel: {},
    itineraryType: 1, //0 = ONE-WAY, 1 = ROUNDTRIP, 2 = MULTI_CITY
    pricedOffer: null, // Store the original priced offer from travel/offer-price
  },
  atc: {}, //details for atc ticket exchange
  recentSearches: [
    /*{
      key: null,
      expiresAt: null,  
      formData: null
    }*/
  ],
  vendors: {},
  flightDetails: {
    show: false,
    journeys: {},
  },
  fareOptions: {
    show: false,
    jsolution: {},
  },
  airports: [{ code: "IND" }],
  formsCollapsed: {
    flight: false,
    car: false,
    hotel: false,
  },
  areResultsOld: {
    flight: false,
    car: false,
    hotel: false,
  },
  showMapView: {
    flight: false,
    car: false,
    hotel: false,
  },
  lastHotelSearch: {},
  searchLoadingStatus: false,
  flightSearchComplete: false,
  //flightSearchMoreResults: [],
  expectedUnbundledJourneysCount: 0,
  selectedUnbundledJourneys: [],
  searchByScheduleFlights: [],
  anchoredSearchTimer: {},
  numGuests: 0,
  guests: [
    /*{ meetingAttendeeGuestId, profile: {}, result: {} }*/
  ],
  paymentOptionsBySegment: {},
  carSearchData: null, // Temporary storage for car search data from HomeV2
  flightFormData: null, // Temporary storage for flight search data from HomeV2
  multiCityFormData: null, // Temporary storage for multi-city flight search data from HomeV2
};

export const mutations = {
  SHOW_FLIGHT_DETAILS(state) {
    state.flightDetails.show = true;
  },
  HIDE_FLIGHT_DETAILS(state) {
    state.flightDetails.show = false;
  },
  SET_FLIGHT_DETAILS(state, payload) {
    state.flightDetails = payload;
  },
  SAVE_SEARCH(state, payload) {
    const { key, expiresAt, formData } = payload;
    let obj = {};
    obj.key = key;
    obj.expiresAt = expiresAt;
    obj.formData = formData;
    state.recentSearches.push(obj);
  }, 
  SAVE_HOTEL_SEARCH(state, formData){

    let form = formData
    //form.checkinDate = moment(formData.checkinDate).toDate() ?? Date()
    //form.checkoutDate = moment(formData.checkoutDate).toDate() ?? Date()
    
    state.lastHotelSearch = form
  },
  // FARE OPTIONS
  SHOW_FARE_OPTIONS(state) {
    state.fareOptions.show = true;
  },
  HIDE_FARE_OPTIONS(state) {
    state.fareOptions.show = false;
  },
  SET_FARE_OPTIONS(state, payload) {
    state.fareOptions = payload;
  },
  SET_NDC_BOOKING(state, payload) {
    const { flight, selectedOffer, pricedOffer } = payload;
    state.result.flight = flight;
    state.result.selectedOffer = selectedOffer;
    // Store pricedOffer separately if provided (from travel/offer-price response)
    if (pricedOffer) {
      state.result.pricedOffer = pricedOffer;
    }
  },
  SET_NDC_BOOKING_GUEST(state, payload) {
    const { flight, selectedOffer, guestIndex, pricedOffer } = payload;
    this._vm.$set(state.guests[guestIndex].result, "flight", flight);
    this._vm.$set(
      state.guests[guestIndex].result,
      "selectedOffer",
      selectedOffer
    );
    // Store pricedOffer separately if provided (from travel/offer-price response)
    if (pricedOffer) {
      this._vm.$set(state.guests[guestIndex].result, "pricedOffer", pricedOffer);
    }
  },
  ALTER_TRIP_VAL(state, payload) {
    state.result.itineraryType = payload;
  },

  ALTER_CAR_RESULT(state, payload) {
    state.result.car = payload;
  },
  ADD_CAR_RESULT(state, payload) {
    state.result.car.push(payload);
  },
  ALTER_FLIGHT_RESULT(state, payload) {
    // update flight
    state.result.flight = payload;
    state.result.selectedOffer = null;
  },
  ALTER_HOTEL_RESULT(state, payload) {
    state.result.hotel = payload;
  },
  ADD_HOTEL_RESULT(state, payload) {
    state.result.hotel.push(payload);
  },
  //
  ADD_RESULT(state, payload) {
    state.result.push(payload);
  },
  SET_ATC_DETAILS(state, payload) {
    //this._vm.$set(state.result, "atc", payload);
    state.atc = payload;
  },
  SET_TRIP_RESULT(state, payload) {
    //need $set to ensure updates are fully reactive in Vue
    this._vm.$set(state.result, "trip", payload);
    //state.result.trip = payload;
  },
  CHANGE_MAIN_RESULT(state, payload) {
    state.result = payload;
  },
  SET_BOOKED(state, payload) {
    state.booked = payload;
  },
  ADD_SEAT(state, payload) {
    state.result.flight.journeys[payload.journeyIndex].legs[
      payload.legIndex
    ].selectedSeat = payload;
  },
  ADD_SEAT_GUEST(state, { guestIndex, selectedSeat }) {
    state.guests[guestIndex].result.flight.journeys[
      selectedSeat.journeyIndex
    ].legs[selectedSeat.legIndex].selectedSeat = selectedSeat;
  },
  VENDORS(state, payload) {
    state.vendors = payload;
  },

  AIRPORTS(state, payload) {
    state.airports = payload;
  },
  COLLAPSE_BOOKING_FORMS(state, payload) {
    state.formsCollapsed[payload.type] = payload.data;
  },
  SET_RESULTS_STATUS(state, payload) {
    state.areResultsOld[payload.type] = payload.data;
  },
  SWITCH_MAP_VIEW(state, payload) {
    state.showMapView[payload.type] = payload.data;
  },
  CLEAR_BOOKING(state) {
    state.formsCollapsed = {
      flight: false,
      car: false,
      hotel: false,
    };
    state.areResultsOld = {
      flight: false,
      car: false,
      hotel: false,
    };
    state.showMapView = {
      flight: false,
      car: false,
      hotel: false,
    };
    state.booked = false;
    state.searchLoadingStatus = false;
    state.flightSearchComplete = false;
    state.flightSearchMoreResults = [];
    state.anchoredSearchTimer = {};
    state.guests = [];
    state.result = {
      trip: {},
      flight: {},
      car: {},
      hotel: {},
      itineraryType: 1, //0 = ONE-WAY, 1 = ROUNDTRIP, 2 = MULTI_CITY
    };
  },
  SET_EXPECTED_UNBUNDLED_JOURNEYS_COUNT(state, payload) {
    state.expectedUnbundledJourneysCount = payload;
  },
  SELECT_UNBUNDLED_JOURNEY(state, payload) {

    const obj = {
      segmentIndex: payload.segmentIndex,
      uniqueKey: payload.uniqueKey,
    }

    console.log('SELECT_UNBUNDLED_JOURNEY', obj);

    state.selectedUnbundledJourneys.splice(obj.segmentIndex - 1, 1, obj);
  },
  UNSELECT_UNBUNDLED_JOURNEY(state, segmentIndex) {

    // Alternatively, if you want to remove the element entirely:
    state.selectedUnbundledJourneys.splice(segmentIndex, 1);
  },
  CLEAR_SELECTED_UNBUNDLED_JOURNEYS(state, payload) {
    state.selectedUnbundledJourneys = [];
    state.expectedUnbundledJourneysCount = 0;
  },
  SET_CAR_SEARCH_DATA(state, payload) {
    state.carSearchData = payload;
  },
  CLEAR_CAR_SEARCH_DATA(state) {
    state.carSearchData = null;
  },
  SET_FLIGHT_FORM_DATA(state, payload) {
    state.flightFormData = payload;
  },
  CLEAR_FLIGHT_FORM_DATA(state) {
    state.flightFormData = null;
  },
  SET_MULTI_CITY_FORM_DATA(state, payload) {
    state.multiCityFormData = payload;
  },
  CLEAR_MULTI_CITY_FORM_DATA(state) {
    state.multiCityFormData = null;
  },
  /*
    ADD_ORIGINAL_PRICE_RANGE(state, payload){
        state[payload.type].originalPriceRange = payload.originalPriceRange;
    },
    */
  ADD_SEARCH_BY_SCHEDULE_FLIGHTS(state, payload) {
    state.searchByScheduleFlights.push(payload);
  },
  FLIGHT_SEARCH_LOADING_STATUS(state, payload) {
    state.searchLoadingStatus = payload;
  },
  FLIGHT_SEARCH_COMPLETE(state, payload) {
    state.flightSearchComplete = payload;
  },
  SET_ANCHORED_SEARCH_TIMER(state, payload) {
    state.anchoredSearchTimer[payload.uniqueKey] = payload;
  },
  /*
  SET_NUM_GUESTS(state, payload) {
    state.numGuests = payload;
  },
  */
  ADD_GUEST_TRIP(state, payload) {
    //state.guests.solutions[payload.id] = payload.flightInfo;
    state.guests.push(payload);
  },
  DEL_GUEST_TRIP(state, index) {
    //state.guests.solutions[payload.id] = payload.flightInfo;
    state.guests.splice(index, 1);
  },
  UPDATE_GUEST_TRIP(state, { index, guest }) {
    Vue.set(state.guests, index, guest);
  },
  DELETE_ALL_GUESTS(state) {
    state.guests.splice(0);
  },
  /*
    ADD_MORE_FLIGHT_RESULTS(state, payload){
        state.flightSearchMoreResults.push(payload);
    },
    ADD_MORE_FLIGHT_RESULTS_MULTIPLE(state, payload) {
        for (let i = 0; i < payload.length; i++) {
            state.flightSearchMoreResults.push(payload[i].uniqueKey);
        }
    },
    CLEAR_MORE_FLIGHT_RESULTS(state){
        state.flightSearchMoreResults = [];
    }
    */
  SET_PAYMENT_OPTIONS(state, payload) {
    // Create a new object to hold the updated payment methods
    const newpaymentOptionsBySegment = {};

    Object.keys(payload).forEach((key) => {
      if (key !== "global") {
        // Update the new object with the new payment methods
        newpaymentOptionsBySegment[key] = payload[key] || [];
      }
    });

    Vue.set(state, "paymentOptionsBySegment", {
      ...state.paymentOptionsBySegment,
      ...newpaymentOptionsBySegment,
    });
  },
  ADD_PERSONAL_PAYMENT_METHOD(state, payload) {
      //By default add to all segments and make it selectable
      payload.isSelectable = true;
      Object.keys(state.paymentOptionsBySegment).forEach((segment) => {
        state.paymentOptionsBySegment[segment].push(payload);
      });
    },
    UPDATE_PERSONAL_PAYMENT_METHOD(state, payload) {
      // Ensure the payment method is selectable
      payload.validExpiration = true;
  
      Object.keys(state.paymentOptionsBySegment).forEach((segment) => {
          const paymentOptions = state.paymentOptionsBySegment[segment];
          const index = paymentOptions.findIndex(option => option.id === payload.id);
  
          if (index !== -1) {
              // Capture isSelectable before deletion
              const isSelectable = paymentOptions[index].isSelectable;
  
              // Remove the payment method from the segment
              paymentOptions.splice(index, 1);
  
              // Assign the captured isSelectable value back to the payload
              payload.isSelectable = isSelectable;
          }
  
          // Add the updated payment method to the segment
          state.paymentOptionsBySegment[segment].push(payload);
      });
  },
  
  CLEAR_PAYMENT_OPTIONS(state) {
    Vue.set(state, "paymentOptionsBySegment", {});
  },
  REMOVE_PAYMENT_OPTIONS(state, segment) {
    if(state.paymentOptionsBySegment && typeof state.paymentOptionsBySegment == "object" && state.paymentOptionsBySegment[segment]) {
      Vue.delete(state.paymentOptionsBySegment, segment);
    }
  },
};

export const actions = {
  /*
  edit_guest_profile({ state, commit }, profileData) {
    let guestIndex = state.guests.findIndex(
      (g) => g.profile.account.id === profileData.account.id
    );

    if (guestIndex > -1) {
      let guest = state.guests[guestIndex];

      const payload = {
        index: guestIndex,
        guest: {
          profile: profileData,
          result: guest.result,
        },
      };
      commit("UPDATE_GUEST_TRIP", payload);
    }
  },
  */
  alterTripVal(context, payload) {
    context.commit("ALTER_TRIP_VAL", payload);
  },
  //MT - This should be alterFlightResult since only updates the flight portion of the result
  alterResult(context, payload) {
    context.commit("ALTER_FLIGHT_RESULT", payload);
  },
  alterCarResult(context, payload) {
    // console.log('alter car result', payload);
    context.commit("ALTER_CAR_RESULT", payload);
  },
  alterHotelResult(context, payload) {
    context.commit("ALTER_HOTEL_RESULT", payload);
  },
  addResult(context, payload) {
    context.commit("ADD_RESULT", payload);
  },
  setNdcBooking(context, { flight, offer, guestId = null, pricedOffer = null }) {
    //Update the SelectedOffer
    //Only save the data needed to price/book the offer

    let selectedOffer = {
      offerId: offer.offerId,
      ownerCode: offer.ownerCode,
      responseId: offer.responseId,
      expireTime: offer.expireTime,
      paymentTimeLimitDateTime: offer.paymentTimeLimitDateTime,
      pricing: offer.pricing,
      journeyList: offer.journeyList,
      bookingClass: offer.bookingClass,
      items: offer.items?.map((item) => {
        return {
          itemId: item.itemId,
          ptc: item.ptc,
          paxRef: item.paxRef,
        };
      }),
    };

    let bookingInfo = {
      flight: flight,
      selectedOffer: selectedOffer,
    };

    // Include pricedOffer if provided (from travel/offer-price response)
    if (pricedOffer) {
      bookingInfo.pricedOffer = pricedOffer;
    }

    if (guestId) {
      let guestIndex = context.state.guests.findIndex(
        (guest) => guest.meetingAttendeeGuestId === guestId
      );

      if (guestIndex > -1) {
        bookingInfo.guestIndex = guestIndex;
        context.commit("SET_NDC_BOOKING_GUEST", bookingInfo);
      }
    } else {
      context.commit("SET_NDC_BOOKING", bookingInfo);
    }
  },
  setAtcDetails(context, payload) {
    context.commit("SET_ATC_DETAILS", payload);
  },
  setTripResult(context, payload) {
    context.commit("SET_TRIP_RESULT", payload);
  },
  addHotelResult(context, payload) {
    context.commit("ADD_HOTEL_RESULT", payload);
  },
  addCarResult(context, payload) {
    context.commit("ADD_CAR_RESULT", payload);
  },
  delResult(context) {
    context.commit("ALTER_FLIGHT_RESULT", {});
  },
  cDelResult(context) {
    context.commit("ALTER_CAR_RESULT", {});
  },
  hDelResult(context) {
    context.commit("ALTER_HOTEL_RESULT", {});
  },
  setBooked(context, payload) {
    context.commit("SET_BOOKED", payload);
  },
  addSeat(context, payload) {
    context.commit("ADD_SEAT", payload);
  },
  vendors(context, payload) {
    context.commit("VENDORS", payload);
  },

  airports(context, payload) {
    context.commit("AIRPORTS", payload);
  },
  collapseBookingForms(context, payload) {
    context.commit("COLLAPSE_BOOKING_FORMS", payload);
  },
  setResultsStatus(context, payload) {
    context.commit("SET_RESULTS_STATUS", payload);
  },
  switchMapView(context, payload) {
    context.commit("SWITCH_MAP_VIEW", payload);
  },
  clearBooking(context) {
    context.commit("CLEAR_BOOKING");
  },
  setPaymentOptions(context, payload) {
    context.commit("SET_PAYMENT_OPTIONS", payload);
  },
  addPersonalPaymentMethod(context, payload) {
    context.commit("ADD_PERSONAL_PAYMENT_METHOD", payload);
  },
  removepaymentOptionsBySegment(context, payload) {
    context.commit("REMOVE_PAYMENT_OPTIONS", payload);
  },
  updatePersonalPaymentMethod(context, payload) {
    context.commit("UPDATE_PERSONAL_PAYMENT_METHOD", payload);
  },
};

export const getters = {
  getAnchoredSearchTime: (state) => (uniqueKey) => {
    if (!state.anchoredSearchTimer) return null;
    let result = state.anchoredSearchTimer[uniqueKey];
    console.log(result);

    if (result) {
      return result.time;
    }

    return null;
  },

  getFlightResults(state) {
    let flightResults = state.result.flight;
    return flightResults;
  },
  getSelectedCarDates(state) {
    let dates = [];
    if (state.result.car.pickupInfo) {
      dates.push(moment(state.result.car.pickupInfo.dateTime.date).toDate());
    }
    if (state.result.car.dropoffInfo) {
      dates.push(moment(state.result.car.dropoffInfo.dateTime.date).toDate());
    }
    return dates;
  },
  getSelectedHotelDates(state) {
    let dates = [];
    if (state.result.hotel.startDate) {
      dates.push(moment(state.result.hotel.startDate).toDate());
    }
    if (state.result.hotel.endDate) {
      dates.push(moment(state.result.hotel.endDate).toDate());
    }
    return dates;
  },
  getSelectedFlightDates(state) {
    if (state.result.flight.startDate) {
      return state.result.flight.journeys.map((x) =>
        moment(x.startDate).toDate()
      );
    } else {
      return [];
    }
  },
  getAllSelectedDates(state, getters) {
    let extraDates = [];
    if (getters.getSelectedFlightDates.length > 0) {
      let flightDates = getters.getSelectedFlightDates.map((x) => {
        return {
          date: moment(x).toDate(),
          type: "is-info",
          segmentType: "flight",
        };
      });
      extraDates = extraDates.concat(flightDates);
    }
    if (getters.getSelectedCarDates.length > 0) {
      // Use all dates
      let carDates = [];
      let fromDate = moment(getters.getSelectedCarDates[0]);
      let toDate = moment(getters.getSelectedCarDates[1]);
      let diff = toDate.diff(fromDate, "days");
      for (let i = 0; i <= diff; i++) {
        let dateInfo = {
          date: moment(fromDate)
            .add(i, "days")
            .toDate(),
          type: "is-success",
          segmentType: "car",
        };
        carDates.push(dateInfo);
      }
      extraDates = extraDates.concat(carDates);
    }
    if (getters.getSelectedHotelDates.length > 0) {
      // Use all dates
      let hotelDates = [];

      let fromDate = moment(getters.getSelectedHotelDates[0]);
      let toDate = moment(getters.getSelectedHotelDates[1]);
      let diff = toDate.diff(fromDate, "days");
      for (let i = 0; i <= diff; i++) {
        let dateInfo = {
          date: moment(fromDate)
            .add(i, "days")
            .toDate(),
          type: "is-danger",
          segmentType: "hotel",
        };
        hotelDates.push(dateInfo);
      }
      extraDates = extraDates.concat(hotelDates);
    }
    return extraDates;
  },
  getFirstSelectedDate(state, getters) {
    let allSelectedDates = getters.getAllSelectedDates;
    if (!allSelectedDates || allSelectedDates.length == 0) return null;
    // Order by date asc
    allSelectedDates.sort((a, b) => a.date - b.date);
    // Get the first date
    let firstSelectedTravelDate = allSelectedDates[0].date;
    return firstSelectedTravelDate;
  },
  getAirports(state) {
    return state.airports;
  },
  getSelectedUnbundledJourneys(state) {
    return state.selectedUnbundledJourneys;
  },
  getExpectedUnbundledJourneysCount(state) {
    return state.expectedUnbundledJourneysCount;
  },
  // Get the selected journey by segment index (starts at 1, not 0)
  getSelectedJourneyBySegment: (state) => (segmentIndex) => {
    return state.selectedUnbundledJourneys.find((x) => x.segmentIndex === segmentIndex);   
  },
  getPaymentOptionsBySegment(state) {
    return state.paymentOptionsBySegment;
  },
  getGlobalPaymentOptions(state) {
    let globalMethods = [];

    const segmented = state.paymentOptionsBySegment;

    if (segmented) {
        const segmentKeys = Object.keys(segmented);

        // Return empty array if there are no segment keys
        if (segmentKeys.length === 0) return [];

        // Start with the methods from the first segment
        globalMethods = segmented[segmentKeys[0]].map(method => ({
            ...method
        }));

        // Iterate through all segment keys
        for (let i = 1; i < segmentKeys.length; i++) {
            const segmentMethods = segmented[segmentKeys[i]];

            globalMethods = globalMethods.map(globalMethod => {
                // Find corresponding method in the current segment/expense type
                const methodInSegment = segmentMethods.find(segMethod => segMethod.id === globalMethod.id);

                // If card exists in segment and is not selectable, mark it as not selectable
                if (methodInSegment && !methodInSegment.isSelectable) {
                    return {
                        ...globalMethod,
                        isSelectable: false 
                    };
                }

                return globalMethod;
            });
        }
    }

    return globalMethods;
}



};
